import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { API_URL } from "../../../../constants";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { Table } from "react-bootstrap";
import moment from "moment";
import { FaSpinner } from "react-icons/fa";
import Pagination from "../../../../components/Pagination";

const AssetHistory = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateNavbarHeading("Asset History"));
  }, []);

  const [loading, setLoading] = useState(false);
  const [assetDetailsData, setAssetDetailsData] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [assetHistoryData, setAssetHistroyData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRecordsPerPage, setSelectedRecordsPerPage] = useState(10);
  useEffect(() => {
    fetchGetAssetHistory(id);
  }, [id]);

  const fetchGetAssetHistory = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}asset-history/${id}`);
      if (response.status === 200) {
        setPageLoading(false);
        const cleanedData = response?.data;
        setAssetDetailsData(cleanedData?.data?.[0]);
        setAssetHistroyData(cleanedData?.getAssetsHistory);
        setLoading(false);
      } else {
        console.error("Failed to fetch asset history:", response.status);
      }
    } catch (error) {
      console.error("Error fetching asset history:", error);
    }
  };

  if (pageLoading) {
    return (
      <p
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
        }}
      >
        <FaSpinner className="spinner" />
      </p>
    );
  }

  const labelStyle = {
    fontWeight: "bold",
    padding: "8px",
    backgroundColor: "#f0f0f0",
  };
  const valueStyle = { padding: "8px" };
  const getAllocationStatus = (status) => {
    const baseStyle = {
      padding: "4px",
      borderRadius: "4px",
      textAlign: "center",
      fontWeight: "bold",
      color: "#fff",
    };
    switch (status) {
      case 0:
        return (
          <p style={{ ...baseStyle, backgroundColor: "#28a745" }}>Allocate</p>
        );
      case 1:
        return (
          <p style={{ ...baseStyle, backgroundColor: "#17a2b8" }}>In Stock</p>
        );
      case 2:
        return (
          <p style={{ ...baseStyle, backgroundColor: "#dc3545" }}>Obsolete</p>
        );
      case 3:
        return (
          <p
            style={{ ...baseStyle, backgroundColor: "#ffc107", color: "#000" }}
          >
            Repairable
          </p>
        );
      default:
        return null;
    }
  };
  const indexOfLastRecord = currentPage * selectedRecordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - selectedRecordsPerPage;
  const currentRecords = assetHistoryData.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  return (
    <div style={{ padding: "10px" }}>
      <div style={{ display: "flex", gap: "20px" }}>
        {/* Asset Details Table */}
        <div
          style={{
            flex: "1",
            backgroundColor: "white",
            borderRadius: "8px",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
            padding: "16px",
          }}
        >
          <div
            style={{
              marginBottom: "12px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <p style={{ fontWeight: "bold", fontSize: "16px" }}>
              Asset Details
            </p>
            {getAllocationStatus(assetDetailsData?.Allocated)}
          </div>
          <Table bordered style={{ fontSize: "14px" }}>
            <tbody>
              <tr>
                <td style={labelStyle}>Asset Name</td>
                <td style={valueStyle}>{assetDetailsData?.AssetName}</td>
              </tr>
              <tr>
                <td style={labelStyle}>Category</td>
                <td style={valueStyle}>{assetDetailsData?.CategoryName}</td>
              </tr>
              <tr>
                <td style={labelStyle}>Make</td>
                <td style={valueStyle}>{assetDetailsData?.Brand}</td>
              </tr>
              <tr>
                <td style={labelStyle}>Model</td>
                <td style={valueStyle}>{assetDetailsData?.Model}</td>
              </tr>
              <tr>
                <td style={labelStyle}>Invoice Date</td>
                <td style={valueStyle}>
                  {assetDetailsData?.PurchaseDate &&
                    moment(assetDetailsData?.PurchaseDate).format(
                      "DD-MMM-YYYY"
                    )}
                </td>
              </tr>
              <tr>
                <td style={labelStyle}>Invoice No.</td>
                <td style={valueStyle}>{assetDetailsData?.InvoiceNumber}</td>
              </tr>
              <tr>
                <td style={labelStyle}>Vendor</td>
                <td style={valueStyle}>{assetDetailsData?.ShopName}</td>
              </tr>
              <tr>
                <td style={labelStyle}>Price</td>
                <td style={valueStyle}>{assetDetailsData?.AssetPrice}</td>
              </tr>
              <tr>
                <td style={labelStyle}>Service No.</td>
                <td style={valueStyle}>{assetDetailsData?.BatchNo}</td>
              </tr>
              <tr>
                <td style={labelStyle}>Warranty Date</td>
                <td style={valueStyle}>
                  {assetDetailsData?.WarrantyDate &&
                    moment(assetDetailsData?.WarrantyDate).format(
                      "DD-MMM-YYYY"
                    )}
                </td>
              </tr>
              <tr>
                <td style={labelStyle}>Description</td>
                <td style={valueStyle}>{assetDetailsData?.Description}</td>
              </tr>
            </tbody>
          </Table>
        </div>

        {/* Asset History Table */}
        <div
          style={{
            flex: "2",
            backgroundColor: "white",
            borderRadius: "8px",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
            padding: "16px",
          }}
        >
          <p style={{ fontWeight: "bold", fontSize: "16px" }}>Asset History</p>
          <Table striped bordered hover size="sm">
            <thead id="thcolor">
              <tr>
                <th className="text-center">Allocated To</th>
                <th className="text-center">Allocated On</th>
                <th className="text-center">Allocated Details</th>
                <th className="text-center">Return On</th>
              </tr>
            </thead>
            <tbody>
              {currentRecords.length !== 0 ? (
                currentRecords.map((ele, index) => (
                  <tr key={index}>
                    <td>{ele?.Name}</td>
                    <td className="text-center">
                      {ele?.Status === "Returned" ? "" : moment(ele?.TXNDate).format("DD-MMM-YYYY")}
                    </td>
                    <td>{ele?.Remarks}</td>
                    <td className="text-center">
                      {ele?.ReturnDate
                        ? moment(ele.ReturnDate).format("DD-MMM-YYYY")
                        : ""}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} style={{ textAlign: "center" }}>
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          <div className="d-flex justify-content-end">
            <div>
              <Pagination
                itemsPerPage={selectedRecordsPerPage}
                totalItems={assetHistoryData.length}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssetHistory;
